<template>
	<div>
		<div class="display-1 font-weight-light mb-3">Existing Applications for {{partnerName}}</div>

		<v-simple-table class="mt-3" v-if="applications.length > 0 && !loading">
			<thead>
			<tr>
				<th class="column text-left">Name</th>
				<th class="column text-left">Description</th>
				<th class="column text-left">Customer</th>
				<th class="column text-left">Region</th>
				<th class="column text-left">Token</th>
				<th class="column text-left">Beta</th>
				<th class="column text-left"></th>
				<th class="column text-left" v-if="isAdmin"></th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="a in applications" :key="a.id">
				<td>{{a.name}}</td>
				<td>{{a.description}}</td>
				<td>{{a.customer}}</td>
				<td>{{a.region}}</td>
				<td style="white-space: nowrap;" class="code">
					<v-btn icon title="Copy" v-clipboard:copy="a.token" v-clipboard:success="() => showToast('success', 'Token Copied')"><v-icon small color="primary">far fa-copy</v-icon></v-btn>
					{{a.token.substring(0,6)}}...
					<v-btn @click="newToken(a.id)" icon text title="New Token"><v-icon small color="primary">far fa-sync-alt</v-icon></v-btn>
				</td>
				<td><v-icon v-if="a.useBetaFeatures">far fa-check-square</v-icon><v-icon v-else>far fa-square</v-icon></td>
				<td><v-btn text color="primary" @click="loadConfig(a.id)">Config</v-btn></td>
				<td v-if="isAdmin"><v-btn text color="warning" @click="deleteApplication(a.id)">Delete</v-btn></td>
			</tr>
			</tbody>
		</v-simple-table>
		<v-alert
			v-if="applications.length === 0 && !loading"
			type="info"
		>
			You don't have any applications
		</v-alert>
		<v-alert
			v-if="loading"
			type="info"
			icon="fa-spin fa-spinner"
		>
			Loading
		</v-alert>

		<add-application v-if="!appConfig && isAdmin" @add="refresh" :partner-id="Number($route.params.id)" />
		<config-application v-if="appConfig" @update="refresh" @close="appConfig = null" :settings="appConfig" />
	</div>
</template>

<script>
import analysisApi from "../analysisApi";
import AddApplication from "../components/applications/application-add.vue";
import ConfigApplication from "../components/applications/application-config.vue";
import { actionTypes } from "../store-types";

export default {
	components: {
		AddApplication,
		ConfigApplication,
	},
	data() {
		return {
			loading: true,
			applications: [],
			partnerName: null,
			appConfig: null,
			partnerId: null,
		};
	},
	created() {
		this.partnerId = this.isAdmin ? this.$route.params.id : this.$store.state.partnerId;
		this.partnerName = this.config.lists.partners.find(p => p.value === Number(this.partnerId)).key;
		this.refresh();
	},
	methods: {
		deleteApplication(id) {
			analysisApi.deleteApplication(id)
				.then(() => {
					this.refresh();
					this.$store.dispatch(actionTypes.LOAD_CONFIG);
					this.showToast("success", "Application Deleted");
				})
				.catch((e) => {
					this.showError(e);
				});
		},
		refresh() {
			analysisApi.existingApplications(this.partnerId)
				.then((r) => {
					this.applications = r.data;
					this.loading = false;
				})
				.catch((e) => {
					this.showError(e);
					this.loading = false;
				});
		},
		newToken(id) {
			analysisApi.generateNewAppToken(id)
				.then(() => {
					this.showToast("success", "New Token Generated");
					this.refresh();
				})
				.catch((e) => {
					this.showError(e);
				});
		},
		loadConfig(id) {
			analysisApi.getApplication(id)
				.then((r) => {
					this.appConfig = r.data;
				})
				.catch((e) => { this.showError(e); });
		},
	},
};
</script>
